import { Badge, Flex, Icon } from "@chakra-ui/react";
import { CheckIcon, WarningTwoIcon } from "@chakra-ui/icons";

export type ChipTone = "success" | "warning" | "neutral";

interface Props {
  tone: ChipTone;
  label: string;
  testId: string;
}

// Neutral is deliberately not a warning: sub-criteria are optional, so "Ingen krav" must not look like
// something that blocks publishing. Amber is reserved for what the publish gate actually rejects.
const TONES: Record<ChipTone, { bg: string; color: string }> = {
  success: { bg: "smSuccessSoft", color: "smSuccess" },
  warning: { bg: "smWarningSoft", color: "smWarning" },
  neutral: { bg: "smBackgroundSecondary", color: "smMuted" },
};

export const AwardStatusChip = ({ tone, label, testId }: Props) => {
  const { bg, color } = TONES[tone];
  return (
    <Badge
      data-testid={testId}
      data-tone={tone}
      bg={bg}
      color={color}
      px="2"
      py="1"
      borderRadius="md"
      fontWeight="medium"
      fontSize="xs"
      textTransform="none"
    >
      <Flex align="center" gap="1.5">
        {tone !== "neutral" && (
          <Icon as={tone === "success" ? CheckIcon : WarningTwoIcon} boxSize="2.5" />
        )}
        {label}
      </Flex>
    </Badge>
  );
};
